import React from "react";
import ReactDOM from "react-dom/client";

// 必须在导入 App 之前设置 dayjs locale
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");

import App from "./App";
import "./i18n/i18n";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
